import { Link } from 'react-router-dom';

export function NotFoundPage() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-3 bg-or-cream-50 px-8 text-center">
      <img
        src="/brand/ollie_logo_square.png"
        alt=""
        width={96}
        height={96}
        aria-hidden
        className="opacity-80"
      />
      <h1 className="font-display text-3xl font-bold text-or-slate-900">Page not found</h1>
      <p className="max-w-sm text-[14px] text-or-slate-600">
        We couldn't find that shelf. Let's get you back to the library.
      </p>
      <Link
        to="/library"
        className="mt-2 inline-flex items-center rounded-full bg-or-orange-500 px-5 py-2 text-[13px] font-semibold text-white shadow-or-btn"
      >
        Back to Library
      </Link>
    </div>
  );
}
